module.exports = __webpack_public_path__ + "img/wrk_30fb5abc44bb87e81f4f05300a8ef481.jpg";


//////////////////
// WEBPACK FOOTER
// ./client/img/wrk.jpg
// module id = 297
// module chunks = 0